// AboutUs 页面相关的翻译资源
export const aboutusResources = {
  zh: {
    // Hero section
    "aboutus.hero.title": "「Genovation」",
    "aboutus.hero.description": "一词结合「基因」（Gene）与「创新」（Innovation），寓意生命延续与科技进步并重",
    
    // Foundation card
    "aboutus.foundation.title": "创生基金",
    "aboutus.foundation.description1": "携程集团联合创办人梁建章博士以个人名义在香港成立",
    "aboutus.foundation.description2": "希望透过经济资助、政策研究支持及文化倡导三大方向",
    "aboutus.foundation.description3": "探索应对低生育率的可行方案",
    
    // Founder section
    "aboutus.founder.sectionTitle": "创始人",
    "aboutus.founder.name": "梁建章",
    "aboutus.founder.nameEn": "James Liang",
    "aboutus.founder.title1": "携程集团联合创始人/董事局主席",
    "aboutus.founder.title2": "人口经济学创新奖专家",
    "aboutus.founder.title3": "北京大学国家发展研究院教授",
    "aboutus.founder.title4": "斯坦福大学经济学博士",
    
    "aboutus.founder.bio.paragraph1": "他于1999年联合创立携程集团，主导企业完成从传统呼叫中心到线上平台，再至移动互联网生态的重要转型。通过战略投资与业务孵化，推动携程发展成为覆盖全球的一站式旅游服务供应商。此外，他还担任其他上市公司的董事会成员。",
    "aboutus.founder.bio.paragraph2": "在人口和社会、创业创新领域，梁建章博士做出了全社会有目共睹的研究努力。他通过多种方式，向公共层面传播国家、社会、企业、个人创新力的关系与价值：出版了《中国人太多了吗？》（2012）、《人口创新力》（2018）、《人口战略》（2023）、《创新主义》（2024）等著作，提出「人口规模和结构决定国家创新力」核心理论，2020年创作人口寓言小说《永生之后》，并将其改编为沉浸式影音剧。",
    "aboutus.founder.bio.paragraph3": "2021年他联合创办了「育娲人口研究」，发布《中国生育成本报告》《中国人口预测报告》等系列研究，警示少子化与老龄化问题；该机构于2024年扩展为「育娲人口智库」。",
    "aboutus.founder.bio.paragraph4": "在企业创新实践方面，梁建章博士深入研究「混合办公」模式，在《Nature》《The Quarterly Journal of Economics》等期刊发表论文，并于2022年在携程全面实践该模式。同时，他致力于将携程集团打造为全球领先的家庭友好型企业，先后推出「5万元生育礼金」、「辅助生育补贴」以及「陪娃假期」等创新型福利项目。",
    "aboutus.founder.bio.paragraph5": "近年来，梁建章博士持续研究创新理论体系，在2024年出版的《创新主义》中将创新提升至哲学维度，首提「创新与传承」的创新价值体系，强调创新力对生命意义的深刻影响。",
    
    // QR Code section
    "aboutus.qrcode.title": "微信公众号",
    "aboutus.qrcode.subtitle": "微信扫一扫关注",
  },
  zh_TW: {
    // Hero section
    "aboutus.hero.title": "「Genovation」",
    "aboutus.hero.description": "一詞結合「基因」（Gene）與「創新」（Innovation），寓意生命延續與科技進步並重",
    
    // Foundation card
    "aboutus.foundation.title": "創生基金",
    "aboutus.foundation.description1": "攜程集團聯合創辦人梁建章博士以個人名義在香港成立",
    "aboutus.foundation.description2": "希望透過經濟補貼、政策研究支持及文化倡導三大方向",
    "aboutus.foundation.description3": "探索應對低生育率的可行方案",
    
    // Founder section
    "aboutus.founder.sectionTitle": "創始人",
    "aboutus.founder.name": "梁建章",
    "aboutus.founder.nameEn": "James Liang",
    "aboutus.founder.title1": "攜程集團聯合創始人/董事局主席",
    "aboutus.founder.title2": "人口經濟學創新獎專家",
    "aboutus.founder.title3": "北京大學國家發展研究院教授",
    "aboutus.founder.title4": "斯坦福大學經濟學博士",
    
    "aboutus.founder.bio.paragraph1": "他於1999年聯合創立攜程集團，帶領企業從傳統聯絡中心發展至網上平台，並進一步邁進流動互聯網生態的轉型。透過戰略投資與業務孵化，推動攜程發展成為覆蓋全球的一站式旅遊服務供應商。此外，他亦擔任其他上市公司的董事會成員。",
    "aboutus.founder.bio.paragraph2": "在人口與社會、創業創新領域，梁建章博士做出了全社會有目共睹的研究努力。他透過多種方式，向公共層面傳播國家、社會、企業、個人創新力的關係與價值：出版了《中國人太多了嗎？》（2012）、《人口創新力》（2018）、《人口戰略》（2023）、《創新主義》（2024）等著作，提出「人口規模和結構決定國家創新力」的核心理論。2020年創作人口寓言小說《永生之後》，並將其改編為沉浸式影音劇。",
    "aboutus.founder.bio.paragraph3": "2021年他聯合創辦「育媧人口研究」，發布《中國生育成本報告》《中國人口預測報告》等系列研究，警示生育率下降與人口高齡化問題；該機構於2024年擴展為「育媧人口智庫」。",
    "aboutus.founder.bio.paragraph4": "在企業創新實踐方面，梁建章博士深入研究「混合辦公」模式，並在頂尖期刊《Nature》《The Quarterly Journal of Economics》等發表論文，於2022年在攜程全面落實該模式。同時，他致力於將攜程集團打造為全球領先的家庭友好型企業，先後推出「5萬元生育禮金」、「輔助生育補貼」以及「陪娃假期」等創新福利項目。",
    "aboutus.founder.bio.paragraph5": "近年來，梁建章博士持續研究創新理論體系，並於2024年出版《創新主義》，將創新提升至哲學層次，首度提出「創新與傳承」的創新價值體系，強調創新力對生命意義的深刻影響。",
    
    // QR Code section
    "aboutus.qrcode.title": "微信公眾號",
    "aboutus.qrcode.subtitle": "微信掃一掃關注",
  },
  en: {
    // Hero section
    "aboutus.hero.title": "「Genovation」",
    "aboutus.hero.description": "The name “Genovation” combines “Gene” and “Innovation”, reflecting a dual commitment to life continuity and technological advancement.",
    
    // Foundation card
    "aboutus.foundation.title": "Genovation Foundation",
    "aboutus.foundation.description1": "Established in Hong Kong by Dr. James Liang, co‑founder of Trip.com Group, in his personal capacity, the foundation explores solutions to low fertility through three key avenues: Financial support (subsidies/grants), Policy research support, Cultural advocacy",
    // "aboutus.foundation.description2": "To explore solutions through three key avenues: ",
    // "aboutus.foundation.description3": "Economic subsidies, support for policy research and cultural advocacy",
    
    // Founder section
    "aboutus.founder.sectionTitle": "Founder",
    "aboutus.founder.name": "梁建章",
    "aboutus.founder.nameEn": "James Liang",
    "aboutus.founder.title1": "Co-founder and Chairman of the Board of Trip.com Group Limited",
    "aboutus.founder.title2": "An expert in demographic economics and innovation",
    "aboutus.founder.title3": "Adjunct Professor at Peking University's National School of Development",
    "aboutus.founder.title4": "PhD. in Economics from Stanford University",
    
    "aboutus.founder.bio.paragraph1": "James Liang co-founded Trip.com Group in 1999 and has led the company’s transformation from a traditional call center to an online platform, and later into a mobile internet ecosystem. Through strategic investments and business incubation, he has helped Trip.com Group grow into a leading one-stop travel services provider with a global presence. He also serves on the boards of several other listed companies.",
    "aboutus.founder.bio.paragraph2": "Dr. Liang is widely recognized for his influential research on China’s demographics, society, entrepreneurship, and innovation, engaging in public advocacy about the value of innovation for nations, societies, enterprises, and individuals. His works include Too Many People in China? (2012), The Demographics of Innovation (2018), Population Strategies (2023), Innovation, Heritage, and Meaning of Life (2024)，in which he proposed the core theory that “a nation’s population size and structure underlie its innovation capacity.” He also authored in 2020 the allegorical novel After Immortality, which was adapted into an immersive play.",
    "aboutus.founder.bio.paragraph3": "In 2021 he co-founded the Yuwa Population Research, which has published reports such as the China Fertility Cost Report and China Population Forecast Report to raise awareness of low fertility and aging challenges. This organization was later expanded into Yuwa Population Institute.",
    "aboutus.founder.bio.paragraph4": "In corporate innovation, Dr. Liang has conducted in-depth research on hybrid work models, with findings published in leading journals such as Nature and The Quarterly Journal of Economics. In 2022, he led Trip.com Group's full implementation of a hybrid work policy. He has also championed the company's development into a global leader in family-friendly workplaces, introducing pioneering benefits such as the \"RMB 50,000 Childcare Subsidies,\" fertility assistance subsidies, and dedicated parental leave.",
    "aboutus.founder.bio.paragraph5": "In recent years, Dr. Liang has continued to advance innovation theory. In his latest work, Innovation, Heritage, and Meaning of Life (2024), he elevates innovation to a philosophical dimension, introducing the \"Innovation and Heritage\" value system while emphasizing the profound impact of innovation on the meaning of life.",
    
    // QR Code section
    "aboutus.qrcode.title": "WeChat Official Account",
    "aboutus.qrcode.subtitle": "Scan to follow",
  }
};

